export type AccountStatus =
  | 'pending_verification'
  | 'active'
  | 'suspended'
  | 'banned'
  | 'rejected';

/** Returns an error message if the user must not log in or use the platform. */
export function getAccountBlockMessage(status: string | undefined | null): string | null {
  switch (status) {
    case 'pending_verification':
      return 'Your account is pending admin approval. You will receive an email once you are approved.';
    case 'rejected':
      return 'Your application was not approved. Please contact support@getblow.app if you have questions.';
    case 'suspended':
      return 'Your account has been suspended. Please contact support.';
    case 'banned':
      return 'Your account has been banned. Please contact support.';
    default:
      return null;
  }
}

export function canAccessPlatform(status: string | undefined | null): boolean {
  return status === 'active';
}
